/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateActivationsControllerRemoveMutationResponse, TemplateActivationsControllerRemovePathParams, TemplateActivationsControllerRemove401, TemplateActivationsControllerRemove403, TemplateActivationsControllerRemove404 } from "../../models/checklistsController/TemplateActivationsControllerRemove";

function getTemplateActivationsControllerRemoveUrl(id: TemplateActivationsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-template-activations/${id}` as const }  
  return res
}

/**
 * @summary Delete a template activation (soft delete)
 * {@link /api/v1/checklist-template-activations/:id}
 */
export async function templateActivationsControllerRemove(id: TemplateActivationsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateActivationsControllerRemoveMutationResponse, ResponseErrorConfig<TemplateActivationsControllerRemove401 | TemplateActivationsControllerRemove403 | TemplateActivationsControllerRemove404>, unknown>({ method : "DELETE", url : getTemplateActivationsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}